import { render, staticRenderFns } from "./modalAddMasterFreight.vue?vue&type=template&id=50d17cf4&scoped=true&"
import script from "./modalAddMasterFreight.vue?vue&type=script&lang=js&"
export * from "./modalAddMasterFreight.vue?vue&type=script&lang=js&"
import style0 from "./modalAddMasterFreight.vue?vue&type=style&index=0&id=50d17cf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d17cf4",
  null
  
)

export default component.exports